import { SET_CONFIG } from './constants';
import { CLEAN_MESSAGES_STORE } from '../Messages/constants';
import { CLEAN_USER_STORE } from '../User/constants';
import { CLEAN_FEEDBACK_STORE } from '../Feedback/constants';
import { CLEAN_SUGGESTIONS_STORE } from '../Suggestions/constants';
import { CLEAN_CONFIG_STORE } from '../Config/constants';

export const setTenantConfig = config => async dispatch => {
  dispatch({ type: SET_CONFIG, payload: config });
};

export const setNewDevTenantConfig = (tenant, env) => async dispatch => {
  const config = require(`../../TenantConfig/config.${tenant}.js`);

  const urlKey = `REACT_APP_API_URL_${env}`;
  const apiUrl = process.env[urlKey];

  const newConfig = { ...config, apiUrl };

  dispatch({ type: CLEAN_CONFIG_STORE });
  dispatch({ type: CLEAN_USER_STORE });
  dispatch({ type: CLEAN_SUGGESTIONS_STORE });
  dispatch({ type: CLEAN_MESSAGES_STORE });
  dispatch({ type: CLEAN_FEEDBACK_STORE });

  dispatch({ type: SET_CONFIG, payload: newConfig });
  return;
};
